import React, { Component, PureComponent } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper/index'
import { TableComp } from 'sz-react-utils'
// import GetAllFormFields from '../../../components/_utils/formUtils'
import { Button, Card, Form, Row, Col, DatePicker, Tooltip, notification, Drawer } from 'antd'
import _ from 'lodash'
import Request, { API_URL } from '../../request'
import { connect } from 'react-redux'
import moment from 'moment'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import { RightsWrapper } from '../../components/_utils/utils'


const { MonthPicker } = DatePicker



class ViewAcknowledgements extends Component {
    state = {
        visible: true,
        acknowledged: []
    }


    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose();
        }, 50)
    }

    constructor(props) {
        super(props);
        this.table = React.createRef();
    }

    showAcknowledged = () => {
        let { record } = this.props;
        let acknowledged = [];
        _.each(record, (details) => {
            if (details.acknowledged === true) {
                acknowledged.push(details);
            }
        })
        this.setState({ acknowledged })
    }



    componentDidMount() {
        this.showAcknowledged()
    }

    render() {
        let { visible } = this.state;
        let columns = [
            {
                title: 'Name',
                key: 'name'
            }
        ]
        return (
            <Drawer
                title={`Acknowledgement Details`}
                placement="right"
                closable={true}
                onClose={this.onClose}
                visible={visible}
                width={500}>
                <Card bordered={true}>
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        dataSource={this.state.acknowledged}
                    />
                </Card>
            </Drawer>
        )
    }
}

@Form.create()
class AddAnnouncement extends Component {
    state = {
        allDepartments: [],
        announcementToDepartment: false
    }

    handleSubmit = (e) => {
        const { form, dispatch, handleSubmit } = this.props
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData);
            handleSubmit(values)
        })
    }

    async componentDidMount() {
        let params = {
            results: 10000,
            count: 10000
        }
        let response = await Request.getAllDepartments(params)
        let allDepartments = []
        _.each(response.data, (department) => {
            allDepartments.push({ id: department.departmentName, display: department.departmentName })
        })
        this.setState({ allDepartments })
    }

    render() {
        const {
            form: { getFieldDecorator }
        } = this.props

        const inputTypes = {
            fields: [

                {
                    label: 'Announcement',
                    type: 'textarea',
                    key: 'annoucementText',
                    rows: 10,
                    required: true
                },
                {
                    label: 'Announce To',
                    key: 'announceTo',
                    type: 'select',
                    required: true,
                    options: [{ id: "Staff", display: "All Users" }, { id: "Department Wise", display: "Departments" }, { id: "HOD's", display: "Department Heads (HOD's)" }, { id: "Branch Heads", display: "Branch Heads" }],
                    onChange: v => {
                        this.props.form.setFieldsValue({ announceTo: v })
                        if (v === "Department Wise") {
                            this.setState({ announcementToDepartment: true })
                        } else {
                            this.setState({ announcementToDepartment: false })
                        }
                    }
                },
                {
                    label: 'Select Department',
                    key: 'department',
                    type: 'select',
                    mode: 'multiple',
                    required: this.state.announcementToDepartment,
                    hidden: !this.state.announcementToDepartment,
                    options: this.state.allDepartments,
                    showSearch: true,
                    onChange: v => {
                        this.props.form.setFieldsValue({ department: v })
                    }
                }
            ]
        }
        return (
            <Card>
                <Form onSubmit={this.handleSubmit}>
                    <GetAllFormFields inputSchema={inputTypes} apiurl={API_URL} getFieldDecorator={getFieldDecorator} />
                    <Row style={{ marginTop: '20px' }}>
                        <Col span={8} />
                        <Col span={8}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{ marginBottom: 10 }}
                                loading={this.props.loading}>
                                Save
                            </Button>
                        </Col>
                        <Col span={8} />
                    </Row>
                </Form>
            </Card>
        )
    }
}


@Form.create()
class Announcements extends PureComponent {
    state = {
        studentId: '',
        activeUser: '',
        count: 0,
        month: moment(),
        defaultPageSize: 20,
        showAnnouncementForm: false,
        showAcknowledgementDetails: false,
        recordId: '',
        acknowledgedDetails: null,
        branchUsersCount: 0
    }



    refreshFxn = () => {
        this.setState({ refreshChild: !this.state.refreshChild })
    }

    handleAnnoucementAction = async (data) => {
        let response = await Request.updateAnnoucement({ _id: data._id });
        if (response.success) {
            notification.success({
                message: response.message
            })
            this.reload()
        } else {
            notification.error({
                message: response.message
            })
        }
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    handleApplicationClick = () => {
        this.setState({ showAnnouncementForm: true })
    }

    closeAcknowledgementDetails = () => {
        this.setState({ showAcknowledgementDetails: false, acknowledgedDetails: null })
    }


    apiRequest = params => {
        return new Promise(async (resolve) => {
            params.month = this.state.month
            let response = await Request.getAllAnnouncements(params);
            this.setState({ count: response.total })
            resolve(response)
        })
    }

    handleMonthChange = (month) => {
        this.setState({ month: moment(month) }, () => {
            this.reload()
        })
    }

    reload = () => {
        this.table.current.reload()
    }

    loadUsers = async () => {
        let activeUser = JSON.parse(localStorage.getItem('user'))
        let params = {}
        params.sortField = 'dateOfJoining'
        params.sortOrder = 'ascend'
        params.userBranch = activeUser.userBranch
        params.active = true
        params.userType = { $ne: "Student" }
        let data = await Request.loadUser({ ...params, regExFilters: ['name', 'email'] })
        this.setState({ branchUsersCount: data.total })
    }

    componentDidMount() {
        let currentUser = JSON.parse(localStorage.getItem('user'));
        this.setState({ activeUser: currentUser._id.toString() })
        this.loadUsers()
    }

    render() {
        const { defaultPageSize, activeUser, recordId, branchUsersCount, showAnnouncementForm, showAcknowledgementDetails, count, oldLeaves, sandwichLeaves, casualLeaves, leavesWithoutPay, leavesWithoutNotice } = this.state
        const columns = [
            {
                title: 'Announced By',
                key: 'announced_by_user.name',
            },
            {
                title: 'Announcement',
                key: 'annoucementText',
            },
            {
                title: 'Total Acknoledgements',
                key: 'acknowledgementCount',
                render: (val, record) => {
                    const totalUsers = record.acknowledgedBy.length || 0;
                    const acknowledgedCount = record.acknowledgedBy.filter(user => user.acknowledged).length;
                    return (
                        <div>
                            <span>{acknowledgedCount}/{totalUsers}</span>
                        </div>
                    );
                }
            },
            {
                title: 'Action',
                key: 'operation',
                render: (text, record) => (
                    <Tooltip title="View Acknowledgements" >
                        <Button shape='circle' icon='eye' size='small' onClick={() => {
                            this.setState({ showAcknowledgementDetails: true, acknowledgedDetails: record.acknowledgedBy })
                        }} />
                    </Tooltip>
                )
            },
        ]


        return (
            <PageHeaderWrapper title={`Announcements:- ${count}`}>
                {
                    this.state.showAcknowledgementDetails ?
                        <ViewAcknowledgements record={this.state.acknowledgedDetails} onClose={this.closeAcknowledgementDetails} />
                        : null
                }
                <Card bordered={true}>
                    <Row>
                        <Col span={4}>
                            <label>Search By Month</label><br />
                            <MonthPicker placeholder='Select Month' defaultValue={moment(this.state.month, 'YYYY-DD')} format="YYYY-MM" onChange={this.handleMonthChange} />
                        </Col>
                        <Col span={2}>
                            <div style={{ textAlign: 'right', marginTop: '15px' }}>
                                <RightsWrapper myRight={"announcements.add"}>
                                    <Button onClick={this.handleApplicationClick} >Add Annoucement </Button>
                                </RightsWrapper>
                            </div>
                        </Col>
                    </Row>
                </Card>
                <Card bordered={true} >
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        extraProps={{ scroll: { x: 900 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: defaultPageSize,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
                <Drawer
                    title="Add Annoucement"
                    placement="right"
                    closable={true}
                    onClose={() => {
                        this.setState({
                            showAnnouncementForm: false,
                        })
                        this.reload()
                    }}
                    visible={showAnnouncementForm}
                    width={600}>
                    <div>
                        <AddAnnouncement
                            loading={this.props.loading}
                            handleSubmit={async (values) => {
                                let response = await Request.addAnnouncement(values);
                                if (response.success) {
                                    notification.success({
                                        message: response.message
                                    })
                                    this.setState({ showAnnouncementForm: false })
                                    this.reload()
                                } else {
                                    notification.error({
                                        message: response.message
                                    })
                                }
                            }}
                        />
                    </div>
                </Drawer>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Announcements)
